<template>
  <div>
    <a-card :bordered="false">
      <a-tabs v-model="currentPaneKey" @tabClick="onTabClick">
        <a-tab-pane tab="已发起报名" key="1">
          <a-table :dataSource="tableData" border style="width: 100%;" :pagination="false">
            <a-table-column data-index="sequence" title="序号"></a-table-column>
            <a-table-column data-index="title" title="报名标题"></a-table-column>
            <!-- <a-table-column dataIndex="schoolYear" title="当前学年"></a-table-column> -->
            <!-- <a-table-column dataIndex="birthDay" title="年龄段限制">
            </a-table-column>-->
            <a-table-column data-index="signupDate" title="报名时间"></a-table-column>
            <a-table-column data-index="reserveDate" title="预约时间"></a-table-column>
            <a-table-column title="状态">
              <template slot-scope="action, record, index">
                <span v-if="(pagination.current-0>1) || (pagination.current-0===1&&index>0)">禁用</span>
                <span v-else>启用</span>
              </template>
            </a-table-column>
            <a-table-column data-index="action" title="操作">
              <template slot-scope="action, record, index">
                <a class="text-operator" @click="handleToDetail(action)">查看</a>
                <!-- <a-button type="primary" @click="handleToDetail(action)">查看</a-button> -->
                <a
                  class="text-operator"
                  v-if="!((pagination.current-0>1) || (pagination.current-0===1&&index>0))"
                  :disabled="(pagination.current-0>1) || (pagination.current-0===1&&index>0)"
                  @click="handleModify(action.id, action.signupNoticeId)"
                >修改</a>
              </template>
            </a-table-column>
            <!-- <a-table :columns="columns" :dataSource="signupList" rowKey="id">
            <template slot="reserveTime" slot-scope="text, record">
              {{record.reserveBegin}} - {{record.reserveEnd}}
            </template>
            <template slot="signupTime" slot-scope="text, record">
              {{record.signupBegin}} - {{record.signupEnd}}
            </template>
            <template slot="action" slot-scope="text, record">
              <a class="text-operator" @click.prevent="editSignUp(record)">[编辑]</a>
            </template>-->
          </a-table>

          <div class="wrapper-pagination" style="margin-top: 20px;text-align:right;">
            <a-pagination
              v-if="pagination.total > pagination.pageSize"
              v-model="pagination.current"
              :pageSize="pagination.pageSize"
              :total="pagination.total"
              :showTotal="total => `总共${total}条`"
              @change="handleChangePage"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane tab="发起报名" key="2">
          <div style="padding-top: 40px;">
            <a-form :form="form" @submit="handleSubmit">
              <a-form-item label="报名标题" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-input
                  placeholder="报名标题不能为空"
                  v-decorator="['title',
                    {rules: [{ required: true, message: '报名标题不能为空!' }]}
                  ]"
                />
              </a-form-item>

              <!-- <a-form-item label="当前学年" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-select
                  placeholder="请选择"
                  @change="handleSelectChange"
                  v-decorator="['schoolYear',
                    {rules: [{ required: true, message: '请选择学年' }]}
                  ]">
                  <a-select-option value="male">2019上</a-select-option>
                  <a-select-option value="female">2019下</a-select-option>
                </a-select>
              </a-form-item>-->

              <a-form-item label="年龄段限制" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-range-picker
                  v-decorator="['birthDayRangeValue',
                    {rules: [{ required: true, message: '请设置年龄段！' }]}
                  ]"
                  size="large"
                  style="width: 100%"
                  :placeholder="['请选择出生日期', '请选择出生日期'] "
                ></a-range-picker>
              </a-form-item>

              <!-- <a-form-item label="报名提示" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-textarea
									v-decorator="['tips',
                    {rules: [{ required: true, message: '字数不能大于120字' }]}
                  ]"
									placeholder="字数不能大于120字"
									:rows="8"></a-textarea>
              </a-form-item>-->

              <a-form-item label="报名日期设置" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-range-picker
                  :disabledDate="disabledDateOfNow"
                  v-decorator="['signupRangeValue',
                    {rules: [{ required: true, message: '请设置报名日期！' }]}
                  ]"
                  size="large"
                  style="width: 100%"
                  :locale="locale"
                  format="YYYY-MM-DD HH:mm"
                  :showTime="{ format: 'HH:mm'}"
                  :placeholder="['请选择报名开始日期', '请选择报名结束日期'] "
                ></a-range-picker>
              </a-form-item>

              <a-form-item label="预约时间设置" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <!-- v-model="reserveRangeValue" -->
                <a-range-picker
                  :disabledDate="disabledDateOfNow"
                  @change="handleChangeReserveRange"
                  v-decorator="['reserveRangeValue',
                    {rules: [{ required: true, message: '请设置预约日期！' }]}
                  ]"
                  :locale="locale"
                  size="large"
                  style="width: 100%"
                  :placeholder="['请选择预约开始时间', '请选择预约结束时间'] "
                ></a-range-picker>
              </a-form-item>

              <a-form-item label="上午预约时间段" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-time-picker
									v-model="reserveTimeValue.amBegin"
									format="HH:mm"
									:minuteStep="15"/> -
                <a-time-picker
									v-model="reserveTimeValue.amEnd"
									format="HH:mm"
									:minuteStep="15"/>
              </a-form-item>

              <a-form-item label="下午预约时间段" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-time-picker
									v-model="reserveTimeValue.pmBegin"
									format="HH:mm"
									:minuteStep="15"/> -
                <a-time-picker
									v-model="reserveTimeValue.pmEnd"
									format="HH:mm"
									:minuteStep="15"/>
              </a-form-item>

              <!-- <a-form-item
								v-for="(item, index) of signupQuotaDomainList"
								:key="index"
								:label-col="{ span: 5 }"
								:wrapper-col="{ span: 16, offset: index === 0 ? 0 : 5 }"
								:label="index === 0 ? '预约人数设置' : false">
                <a-date-picker
									:disabledDate="disabledDate"
									v-model="item.quotaDate"
									placeholder="选择日期"/>

                <a-select placeholder="请选择"
									style="display: inline-block; width: 100px; margin-left: 10px;"
									v-model="item.amPmType">
                  <a-select-option value="1">上午</a-select-option>
                  <a-select-option value="2">下午</a-select-option>
                </a-select>
                <span style="display: inline-block; padding: 0 20px;">
                  人数限制
                  <a-input-number
									placeholder="输入数字"
									:min="1"
									v-model="item.limitNum"
									style="display: inline-block; width: 100px; margin-left: 10px;"/>
                </span>
                <a-button @click="onClickAddSubItem(index)" type="primary" ghost>+</a-button>
                <a-button @click="onClickDelSubItem(index)" v-if="signupQuotaDomainList.length >= 2 || index!==0">-</a-button>
              </a-form-item>-->

              <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                <a-button size="large" type="primary" html-type="submit">提 交</a-button>
              </a-form-item>
            </a-form>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import AdminCommon from "./mixins/admin_common";
import moment from "moment";
import locale from "../../utils/locale";

export default {
  mixins: [AdminCommon],
  components: {},
  data() {
    return {
      locale: locale,
      editType: "edit", // edit-编辑状态 add-新增
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      signupQuotaDomainList: [],

      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      currentPaneKey: "1",

      currentNoticeId: "", // 当前报名信息的id

      tableData: [],

      birthDayRangeValue: [],
      // 报名时间
      signupRangeValue: [],
      // 预约时间
      reserveRangeValue: [],
      // 预约时间段
      reserveTimeValue: {
        amBegin: moment("9:00", "HH:mm"),
        amEnd: moment("12:00", "HH:mm"),
        pmBegin: moment("14:00", "HH:mm"),
        pmEnd: moment("17:00", "HH:mm")
      }
    };
  },

  computed: {
    currentSignupNotice() {
      return this.tableData.find(v => v.id === this.currentNoticeId) || {};
    }
  },

  created() {
    let { systemLevel, adminLevel, user } = this.$store.state;
    console.log(
      "[-> Signup List] created 用户信息如下::::",
      "[studentType:]",
      this.studentType,
      "[systemLevel:]",
      systemLevel,
      "[adminLevel:]",
      adminLevel,
      "[user:]",
      user
    );

    this.getSignupList();
  },
  methods: {
    moment,
    onClickAddSubItem(index) {
      this.signupQuotaDomainList.splice(index + 1, 0, { limitNum: 100 });
    },
    onClickDelSubItem(index) {
      if (this.signupQuotaDomainList.length > 1) {
        this.signupQuotaDomainList.splice(index, 1);

        // var fruits = ["Banana", "Orange", "Apple", "Mango"];
        // console.log(fruits);
        // fruits.splice(2,0,"Lemon","Kiwi");
        // console.log(fruits);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      if (this.isSubmiting) return console.log("防止二次点击");
      this.isSubmiting = true;
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.fetchAddOrUpdateNotice();
        } else {
          this.isSubmiting = false;
        }
      });
    },
    handleSelectChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        note: `Hi, ${value === "male" ? "man" : "lady"}!`
      });
    },

    handleChangePage() {
      this.$nextTick(() => {
        this.getSignupList();
      });
    },
    handleToDetail(action) {
      console.log(action);
      this.$router.push({path:"street_manage_detail",query:{id:action.id}});
    },
    handleModify(id, signupNoticeId) {
      this.currentNoticeId = id;

      this.editType = "edit";
      this.currentPaneKey = "2";

      // this.$nextTick(() => {
      // 	this.setNoticeFormValue();
      // });
      this.getNoticeInfo(id);
    },

    handleChangeReserveRange(momentValueArr) {
      console.log("momentValueArr", momentValueArr);
      this.setSingnupQuotaList(momentValueArr);
    },

    onTabClick(key) {
      if (this.currentPaneKey == key) return;

      this.currentPaneKey = key;

      if (key == 2) {
        this.editType = "add";

        this.$nextTick(() => {
          this.resetNoticeFormValue();
        });
      }
    },

    setSingnupQuotaList(momentValueArr) {
      let beginTime = moment(momentValueArr[0]),
        endTime = momentValueArr[1];

      this.signupQuotaDomainList = [];

      while (endTime == moment.max(beginTime, endTime)) {
        this.signupQuotaDomainList.push(
          {
            quotaDate: moment(beginTime),
            amPmType: "1", // 1-上午 2-下午
            limitNum: 100
          },
          {
            quotaDate: moment(beginTime),
            amPmType: "2", // 1-上午 2-下午
            limitNum: 100
          }
        );

        beginTime.add(1, "days");
      }

      this.signupQuotaDomainList.push(
        {
          quotaDate: moment(endTime),
          amPmType: "1", // 1-上午 2-下午
          limitNum: 100
        },
        {
          quotaDate: moment(endTime),
          amPmType: "2", // 1-上午 2-下午
          limitNum: 100
        }
      );
    },

    resetNoticeFormValue() {
      this.form.setFieldsValue({
        title: "",
        // tips: '',
        birthDayRangeValue: [],
        signupRangeValue: [],
        reserveRangeValue: []
      });

      // this.birthDayRangeValue = [];

      // this.signupRangeValue = [];

      // this.reserveRangeValue = [];

      Object.assign(this.reserveTimeValue, {
        amBegin: moment("9:00", "HH:mm"),
        amEnd: moment("12:00", "HH:mm"),
        pmBegin: moment("14:00", "HH:mm"),
        pmEnd: moment("17:00", "HH:mm")
      });

      this.signupQuotaDomainList = [];
    },

    setNoticeFormValue() {
      let {
        // tips,
        title,
        birthdayBegin,
        birthdayEnd,
        signupBegin,
        signupEnd,
        reserveBegin,
        reserveEnd,
        amBegin,
        amEnd,
        pmBegin,
        pmEnd,
        signupQuotaDomainList
      } = this.currentSignupNotice;

      this.form.setFieldsValue({
        title,
        // tips,
        birthDayRangeValue: [
          moment(birthdayBegin, "YYYY-MM-DD"),
          moment(birthdayEnd, "YYYY-MM-DD")
        ],
        signupRangeValue: [
          moment(signupBegin, "YYYY-MM-DD HH:mm"),
          moment(signupEnd, "YYYY-MM-DD HH:mm")
        ],
        reserveRangeValue: [
          moment(reserveBegin, "YYYY-MM-DD"),
          moment(reserveEnd, "YYYY-MM-DD")
        ]
      });

      Object.assign(this.reserveTimeValue, {
        amBegin: moment(amBegin, "HH:mm"),
        amEnd: moment(amEnd, "HH:mm"),
        pmBegin: moment(pmBegin, "HH:mm"),
        pmEnd: moment(pmEnd, "HH:mm")
      });

      // signupQuotaDomainList.forEach(v => {
      //   v.quotaDate = moment(v.quotaDate, "YYYY-MM-DD");
      //   v.amPmType = v.amPmType + "";
      // });

      // this.signupQuotaDomainList = signupQuotaDomainList || [];
    },

    validateMoment(m, type) {
	  let formatString = "YYYY-MM-DD";
	  if(type == 2) formatString = "HH:mm";
	  if(type == 3) formatString = "YYYY-MM-DD HH:mm";

      if (m && m.format) {
        return m.format(formatString);
      } else {
        return "";
      }
    },

    disabledDate(current) {
      let reserveRangeValue = this.form.getFieldValue("reserveRangeValue");

      let start = reserveRangeValue[0] || "",
        end = reserveRangeValue[1] || "";
      // Can not select days before today and today
      return (
        (current && current < moment(start).startOf("day")) ||
        current > moment(end).endOf("day")
      );
    },

    disabledDateOfNow(current) {
      return current && current < moment().startOf("day");
    },

    async getNoticeInfo(signupNoticeId) {
      // 报名活动详情（区管理员和街道管理员共用） #陈昕/2020-04-13#
      let {data} = await this.$ajax.gateway("/bm/ISignupNoticeApi_detail", {
          "METHOD": "get",
          "noticeId": signupNoticeId
      });

      if (data.code == 200) {
        data = data.data;
        Object.assign(this.currentSignupNotice, data.signupNoticeDomain, {
          signupQuotaDomainList: data.signupQuotaDomains
        });

        this.$nextTick(() => {
          this.setNoticeFormValue();
        });
      }
    },

    // 获取已发起报名的列表
    async getSignupList() {
      let { current, pageSize } = this.pagination;
      // 分页查询通知列表 #李茹钰/2019-03-12#
      let { data, error } = await this.$ajax.gateway(
        "/bm/ISignupNoticeApi_pageSignupNotice",
        {
          body: {
            pageableDto: {
              page: current,
              size: pageSize,
              sort: "asc",
              sortProperties: []
            },
            studentType: this.studentType
          }
        }
      );

      if (data) {
        data = data.data;
        this.tableData = this.formatTableData(data.dataList);
        this.pagination.total = data.totalCount;
        // console.log('tableData', this.tableData);
      }
    },

    // 提交报名信息
    async fetchAddOrUpdateNotice() {
      let { amBegin, amEnd, pmBegin, pmEnd } = this.reserveTimeValue;
      let obj;

      if (this.editType == "edit") {
        obj = this.currentSignupNotice;
      } else {
        obj = {
          id: "",
          areaCode: this.$store.state.user.areaId,
          areaName: this.$store.state.user.areaName
        };
      }

      let { id, areaCode, areaName } = obj;

      let {
        title,
        // tips,
        birthDayRangeValue,
        reserveRangeValue,
        signupRangeValue
      } = this.form.getFieldsValue([
        "signupRangeValue",
        "reserveRangeValue",
        "birthDayRangeValue",
        "title"
      ]);

      // console.log('getFieldsValue', birthDayRangeValue, reserveRangeValue, signupRangeValue, title, tips);

      let signupQuotaDomainList = this.signupQuotaDomainList.map(
        ({ amPmType, limitNum, quotaDate, id, signupNoticeId }) => {
          return {
            amPmType,
            delFlag: false,
            hasNum: "",
            limitNum,
            quotaDate: this.validateMoment(quotaDate),

            signupNoticeId: signupNoticeId || obj.id,
            id: id || obj.id
          };
        }
      );
      // 编辑或信息通知模型 #李茹钰/2019-03-12#
      // let { data, error } = await this.$ajax.gateway('/bm/ISignupNoticeApi_updateOrAdd', {
      // 	body: {
      // 		amBegin: this.validateMoment(amBegin, 2),
      // 		amEnd: this.validateMoment(amEnd, 2),
      // 		areaCode,
      // 		areaName,
      // 		birthdayBegin: this.validateMoment(birthDayRangeValue[0]),
      // 		birthdayEnd: this.validateMoment(birthDayRangeValue[1]),
      // 		delFlag: false,
      // 		pmBegin: this.validateMoment(pmBegin, 2),
      // 		pmEnd: this.validateMoment(pmEnd, 2),
      // 		reserveBegin: this.validateMoment(reserveRangeValue[0]),
      // 		reserveEnd: this.validateMoment(reserveRangeValue[1]),
      // 		schoolYear: '',
      // 		signupBegin: this.validateMoment(signupRangeValue[0]),
      // 		signupEnd: this.validateMoment(signupRangeValue[1]),
      // 		// 使用通知id
      // 		signupNoticeId: id,
      // 		id,
      // 		signupQuotaDomainList,
      // 		studentType: this.studentType,
      // 		// tips,
      // 		title
      // 	}
      // });
      // 添加或编辑信息通知模型（仅区管理员可用） #吴昂/2020-04-13#
      let { data, error } = await this.$ajax.gateway(
        "/bm/ISignupNoticeApi_updateOrAddHalf",
        {
          body: {
            amBegin: this.validateMoment(amBegin, 2),
            amEnd: this.validateMoment(amEnd, 2),
            // areaCode,
            // areaName,
            birthdayBegin: this.validateMoment(birthDayRangeValue[0]),
            birthdayEnd: this.validateMoment(birthDayRangeValue[1]),
            // delFlag: false,
            pmBegin: this.validateMoment(pmBegin, 2),
            pmEnd: this.validateMoment(pmEnd, 2),
            reserveBegin: this.validateMoment(reserveRangeValue[0]),
            reserveEnd: this.validateMoment(reserveRangeValue[1]),
            // schoolYear: '',
            signupBegin: this.validateMoment(signupRangeValue[0],3),
            signupEnd: this.validateMoment(signupRangeValue[1],3),
            // 使用通知id
            // signupNoticeId: id,
            id,
            // signupQuotaDomainList,
            studentType: this.studentType,
            // tips,
            title
          }
        }
      );

      this.isSubmiting = false;

      let msg = this.editType == "edit" ? "修改" : "新增";

      if (data.code === 200) {
        this.$message.success(msg + "报名信息成功");
        this.currentPaneKey = "1";
        this.getSignupList();
      } else {
        this.$message.error(msg + "报名信息失败：" + data.message);
      }
    },

    // 格式化数据
    // 将 birthDayBegin 和 birthDayEnd 合并为 birthDay
    // 将 signupBegin 和 signupEnd 合并为 signup
    formatTableData(data) {
      data.forEach((v, index) => {
        v.key = v.id;
        v.birthDay = v.birthdayBegin + "至" + v.birthdayEnd;
        v.signupDate = v.signupBegin + "至" + v.signupEnd;
        v.reserveDate = v.reserveBegin + "至" + v.reserveEnd;
        v.sequence =
          (this.pagination.current - 1) * this.pagination.pageSize + index + 1;
        v.action = {
          id: v.id,
          allowUpdate: v.allowUpdate,
          signupNoticeId: v.signupNoticeId
        };
      });

      return data;
    }
  }
};
</script>

<style lang="stylus" scoped></style>
